import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const VIDEO_SOURCES = {
  en: '/IAM-Risk-video-EN.mp4',
  pt: '/IAM-Risk-video-PT.mp4',
  it: '/IAM-Risk-video-IT.mp4',
};

const Bridge = () => {
  const { t, lang } = useLanguage();
  const videoSrc = VIDEO_SOURCES[lang] || VIDEO_SOURCES.en;

  return (
    <section
      id="bridge"
      className="relative overflow-hidden py-24 lg:py-28 border-t border-b border-[rgba(232,200,136,0.08)] scroll-mt-24"
    >
      {/* fundo — imagem com blur + overlay escuro para manter contraste */}
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center scale-110 blur-md opacity-90"
        style={{ backgroundImage: "url('/background-bridge.png')" }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at top, rgba(17,28,46,0.25) 0%, rgba(11,19,33,0.55) 65%)',
        }}
      />

      <div className="relative z-10 w-full px-6 lg:px-16">
        <div className="relative flex flex-col md:flex-row items-center fade-up">

          {/* metade esquerda — vídeo com altura fixa, proporção preservada */}
          <div className="w-full md:w-1/2 flex justify-center items-center h-[420px] md:h-[520px]">
            <video
              key={lang}
              className="h-full w-auto max-w-full object-contain rounded-xl border border-[rgba(212,175,55,0.25)] shadow-[0_20px_60px_rgba(0,0,0,0.5)] opacity-95"
              controls
              playsInline
              aria-hidden="true"
            >
              <source src={videoSrc} type="video/mp4" />
            </video>
          </div>

          {/* signature gold rule */}
          <div
            aria-hidden
            className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2"
            style={{
              background:
                'linear-gradient(180deg, rgba(232,200,136,0) 0%, #D4AF7A 20%, #E8C888 50%, #D4AF7A 80%, rgba(232,200,136,0) 100%)',
              opacity: 0.6,
            }}
          />
          <div
            aria-hidden
            className="block md:hidden h-px w-16 mx-auto my-8"
            style={{
              background: 'linear-gradient(90deg, #D4AF7A 0%, #E8C888 50%, #D4AF7A 100%)',
              opacity: 0.6,
            }}
          />

          {/* metade direita — texto centralizado verticalmente */}
          <div className="w-full md:w-1/2 flex flex-col justify-center text-center md:text-left px-0 md:pl-14 lg:pl-20">
            <p className="dash-title mb-6">{t.bridge.eyebrow}</p>
            <p className="font-serif text-2xl md:text-[1.85rem] leading-[1.45] light-text mb-6 max-w-xl">
              {t.bridge.lead}
            </p>
            <p className="text-[#9CA3AF] text-base md:text-lg leading-relaxed font-light max-w-xl mb-3">
              {t.bridge.body}
            </p>
            <p className="text-[#9CA3AF] text-base md:text-lg leading-relaxed font-bold max-w-xl">
              {t.bridge.highlight}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bridge;
